export const UPDATE_NOTIFICATION = 'EMAIL/UPDATE_NOTIFICATION';
export const UPDATE_NOTIFICATION_SUCCESS = 'EMAIL/UPDATE_NOTIFICATION_SUCCESS';
export const SET_NOTIFICATIONS = 'EMAIL/SET_NOTIFICATIONS';
export const RESTORE_SEARCH_NOTIFICATIONS = 'EMAIL/RESTORE_SEARCH_NOTIFICATIONS';
export const DELETE_SEARCH_NOTIFICATION_SUCCESS = 'EMAIL/DELETE_SEARCH_NOTIFICATION_SUCCESS';
export const DELETE_SEARCH_NOTIFICATION_ERROR = 'EMAIL/DELETE_SEARCH_NOTIFICATION_ERROR';
export const DISABLE_NOTIFICATION = 'EMAIL/DISABLE_NOTIFICATION';
export const DISABLE_NOTIFICATION_SUCCESS = 'EMAIL/DISABLE_NOTIFICATION_SUCCESS';
export const SET_NOTIFICATION_WEEKLY_FREQUENCY = 'EMAIL/SET_NOTIFICATION_WEEKLY_FREQUENCY';
export const SET_NOTIFICATION_WEEKLY_FREQUENCY_SUCCESS =
  'EMAIL/SET_NOTIFICATION_WEEKLY_FREQUENCY_SUCCESS';



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/SearchNotifications/actionTypes.js